export const Page404 = () => {

  return(
    <h1>Page not found! Error 404!</h1>
  )
}
